

import { Entity, Key } from '@briebug/ngrx-auto-entity';
import { User } from 'app/main/user/user.model';

@Entity({ modelName: "Favoris", uriName: "favoris" })
export class Favoris {
	@Key id: number;
	name: string;
	rowVersion: number;
	shortcutItem: string;
	user: User;
}


